// editor-utils.js

import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import {
  messageBoxHideAction,
  messageBoxShowAction,
} from 'src/reducers/message-box/action'
import ButtonOptionsModal from '../actions/button-options-modal'
import SelectedIcon from 'src/components/selected-icon'
import {
  handleAddEmbed,
  handleAddInterActive,
} from 'src/components/editor/utils'
import BlockOptionsModal from '../simple-box-wrapper-options/block-options'
import HeaderSettings from '../../../../landing-page/landing-page-editor/components/landing-page-header/header-settings'
import { ButtonActionType, ButtonData, ButtonType } from 'src/model/button'
import { patchCourseLandingPageAction } from 'src/reducers/course/action'
import { patchCollectionLandingPageAction } from 'src/reducers/collection/action'

export const removeAlldropAreaWides = (writer, editor) => {
  const root = editor.model.document.getRoot()
  const dropAreaWides = Array.from(root.getChildren()).filter(
    child => child.name === 'dropAreaWide',
  )

  dropAreaWides.forEach(dropAreaWide => {
    const index = Array.from(root.getChildren()).indexOf(dropAreaWide)
    const prevElement = index > 0 ? root.getChild(index - 1) : null
    const nextElement =
      index < root.childCount - 1 ? root.getChild(index + 1) : null

    writer.remove(dropAreaWide)

    if (prevElement && prevElement.name === 'simpleBoxWrapper') {
      updateButtonVisibility(prevElement, editor)
    }
    if (nextElement && nextElement.name === 'simpleBoxWrapper') {
      updateButtonVisibility(nextElement, editor)
    }
  })
}

export const addDragListeners = dragAreaElement => {
  dragAreaElement.addEventListener('dragover', e => {
    e.preventDefault()
    dragAreaElement.classList.add('drag-over')
  })

  dragAreaElement.addEventListener('dragleave', e => {
    e.preventDefault()
    dragAreaElement.classList.remove('drag-over')
  })

  dragAreaElement.addEventListener('drop', e => {
    e.preventDefault()
    dragAreaElement.classList.remove('drag-over')
  })
}
export const handleAddButton = editor => {
  editor.model.change(writer => {
    const selection = editor.model.document.selection
    const simpleBox = selection.getSelectedElement()
    const simpleButton = writer.createElement('simpleButton', {
      href: '',
      textcolor: '#002E47',
      text: 'Button',
      type: 'link',
      pdfname: '',
    })

    const text = writer.createText('Button')

    const simpleIcon = writer.createElement('simpleIcon', {
      icon: '',
      iconname: 'lets-icons:add-round',
    })
    writer.append(simpleIcon, simpleButton)
    writer.append(text, simpleButton)

    if (simpleBox) {
      // Function to find buttonWrapper
      const findButtonWrapper = element => {
        if (!element || !element.is('element')) return null

        if (element.name === 'buttonWrapper') {
          return element
        }

        for (const child of element.getChildren()) {
          const result = findButtonWrapper(child)
          if (result) {
            return result
          }
        }

        return null
      }

      // Find buttonWrapper in simpleBox
      const buttonWrapper = findButtonWrapper(simpleBox)

      if (buttonWrapper) {
        const flexSize = buttonWrapper.getAttribute('flex-size')

        if (flexSize === '3/1') {
          writer.append(
            simpleButton,
            editor.model.document.selection.getSelectedElement(),
          )
        } else {
          writer.append(simpleButton, buttonWrapper)
        }
      } else {
        // Fallback if no buttonWrapper found
        writer.append(simpleButton, simpleBox)
      }
    }
  })
}
export const handleAddNumberedCard = editor => {
  const selection = editor.model.document.selection
  const selectedElement = selection.getSelectedElement()
  const positionElement = selectedElement.getChild(0).getChild(0)

  const typeCard = selectedElement.getChild(0).getChild(0).getChild(0)

  if (typeCard.getAttribute('type') === 'numberedCard') {
    editor.model.change(writer => {
      // Create the main card element
      const cardBox = writer.createElement('cardBox', {
        type: 'numberedCard',
      })

      // Create number container
      const cardHeader = writer.createElement('cardHeader')
      const pNumber = writer.createElement('paragraph')
      const number = '0' + (positionElement?._children?._nodes?.length + 1)
      const textNumber = writer.createText(number.toString())

      // Create content container
      const cardContent = writer.createElement('cardContent')
      const pContent = writer.createElement('paragraph')
      const textContent = `I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!`
      // Build the structure safely
      writer.append(cardHeader, cardBox)
      writer.append(pNumber, cardHeader)
      writer.append(textNumber, pNumber)

      writer.append(cardContent, cardBox)
      writer.append(pContent, cardContent)
      writer.append(textContent, pContent)

      // Insert at the correct position
      if (selectedElement) {
        writer.append(cardBox, positionElement)
      } else {
        writer.append(cardBox, positionElement)
      }
    })
  } else if (typeCard.getAttribute('type') === 'flipCard') {
    editor.model.change(writer => {
      // Create the main card element
      const cardBox = writer.createElement('cardBox', {
        type: 'flipCard',
      })

      // Create number container
      const flipCardFront = writer.createElement('flipCardFront')
      const flipCardBack = writer.createElement('flipCardBack')
      const number = '0' + (positionElement?._children?._nodes?.length + 1)
      const textNumber = writer.createText(number.toString())
      const pContentFront = writer.createElement('paragraph')
      const pContentBack = writer.createElement('paragraph')
      const flipCardFrontText =
        `Front of Card ` + (positionElement?._children?._nodes?.length + 1)
      const flipCardBackText =
        `Back of Card ` + (positionElement?._children?._nodes?.length + 1)
      // Build the structure safely
      writer.append(flipCardFront, cardBox)
      writer.append(flipCardBack, cardBox)
      writer.append(pContentFront, flipCardFront)
      writer.append(pContentBack, flipCardBack)

      writer.append(flipCardFrontText, pContentFront)
      writer.append(flipCardBackText, pContentBack)

      // Insert at the correct position
      if (positionElement) {
        const position = writer.createPositionAt(positionElement, 'end')
        writer.insert(cardBox, position)
        editor.editing.reconvertItem(positionElement)
        editor.editing.view.forceRender()
      } else {
        const position = selection.getFirstPosition()
        writer.insert(cardBox, position)
        editor.editing.reconvertItem(positionElement)
        editor.editing.view.forceRender()
      }
    })
  } else {
    editor.model.change(writer => {
      // Create the main card element
      const cardBox = writer.createElement('cardBox', {
        type: 'highlightCard',
      })

      // Create number container
      const cardHeader = writer.createElement('cardHeader')
      const cardIconButton = writer.createElement('cardIconButton')
      const simpleIcon = writer.createElement('simpleIcon', {
        icon: 'lets-icons:add-round',
        iconname: 'lets-icons:add-round',
      })

      // Create content container
      const cardContent = writer.createElement('cardContent')
      const pContent = writer.createElement('paragraph')
      const textContent = `Normal text`
      // Build the structure safely
      writer.append(cardHeader, cardBox)
      writer.append(cardIconButton, cardHeader)
      writer.append(simpleIcon, cardIconButton)

      writer.append(cardContent, cardBox)
      writer.append(pContent, cardContent)
      writer.append(textContent, pContent)

      // Insert at the correct position
      if (selectedElement) {
        writer.append(cardBox, positionElement)
      } else {
        writer.append(cardBox, positionElement)
      }
    })
  }
}
export const removeDropAreaNarrow = editor => {
  editor.editing.view.change(writer => {
    const viewRoot = editor.editing.view.document.getRoot()

    for (const child of viewRoot.getChildren()) {
      if (child.is('element') && child.hasClass('drop-area-wide')) {
        writer.removeClass('drop-area-wide', child)
        writer.addClass('empty-dom', child)
      }
      if (child.is('element') && child.hasClass('drop-area-narrow')) {
        writer.removeClass('drop-area-narrow', child)
        writer.addClass('empty-dom', child)
      }
    }
  })
}

export const createDropFromHtml = (writer, html, editor) => {
  const viewFragment = editor.data.processor.toView(html)
  const modelFragment = editor.data.toModel(viewFragment)
  const dropAreaWide = writer.createElement('dropAreaWide')
  writer.append(modelFragment, dropAreaWide)
  return dropAreaWide
}

export const adddropAreaWidesAroundAll = (writer, position = null, editor) => {
  const root = window.editor.model.document.getRoot()
  const simpleBoxWrappers = Array.from(root.getChildren()).filter(
    child => child.name === 'simpleBoxWrapper',
  )
  const editorOutlines = Array.from(root.getChildren()).filter(
    child => child.name === 'editorOutline',
  )

  // Remove all existing drag areas first
  const dragAreas = Array.from(root.getChildren()).filter(
    child => child.name === 'dropAreaNarrow',
  )
  dragAreas.forEach(dragArea => {
    window.editor.model.change(writer => {
      writer.remove(dragArea)
    })
  })

  // Helper function to check if element is any type of drop area
  const isdropAreaWide = element => {
    return (
      element &&
      (element.name === 'dropAreaWide' ||
        element.name === 'dropAreaWideWrapper' ||
        element.name === 'dropAreaNarrow')
    )
  }

  // Add drop areas before each wrapper and after the last one
  simpleBoxWrappers.forEach((wrapper, index) => {
    const wrapperIndex = Array.from(root.getChildren()).indexOf(wrapper)
    const previousElement =
      wrapperIndex > 0 ? root.getChild(wrapperIndex - 1) : null
    const nextElement =
      wrapperIndex < root.childCount - 1
        ? root.getChild(wrapperIndex + 1)
        : null

    if (!isdropAreaWide(previousElement)) {
      window.editor.model.change(writer => {
        const dropAreaWide = writer.createElement('dropAreaNarrow')
        writer.insert(dropAreaWide, wrapper, 'before')
      })
    }

    if (
      index === simpleBoxWrappers.length - 1 &&
      !isdropAreaWide(nextElement)
    ) {
      window.editor.model.change(writer => {
        const lastdropAreaWide = writer.createElement('dropAreaNarrow')
        writer.insert(lastdropAreaWide, wrapper, 'after')
      })
    }

    addDragListenersWithTimeout()
  })
  editorOutlines.forEach((wrapper, index) => {
    const wrapperIndex = Array.from(root.getChildren()).indexOf(wrapper)
    const previousElement =
      wrapperIndex > 0 ? root.getChild(wrapperIndex - 1) : null
    const nextElement =
      wrapperIndex < root.childCount - 1
        ? root.getChild(wrapperIndex + 1)
        : null

    if (!isdropAreaWide(previousElement)) {
      window.editor.model.change(writer => {
        const dropAreaWide = writer.createElement('dropAreaNarrow')
        writer.insert(dropAreaWide, wrapper, 'before')
      })
    }

    if (
      index === simpleBoxWrappers.length - 1 &&
      !isdropAreaWide(nextElement)
    ) {
      window.editor.model.change(writer => {
        const lastdropAreaWide = writer.createElement('dropAreaNarrow')
        writer.insert(lastdropAreaWide, wrapper, 'after')
      })
    }

    addDragListenersWithTimeout()
  })

  // Handle case when no wrappers exist
  if (simpleBoxWrappers.length === 0 && position) {
    handleNoWrappersCase(position, root, isdropAreaWide)
  }
}

const hideAllMessageBoxes = dispatch => {
  dispatch(messageBoxHideAction())
}
export const handleButtonOptions = (dispatch, editor, target) => {
  hideAllMessageBoxes(dispatch)
  const selectedElement = editor.model.document.selection.getSelectedElement()

  // Add click outside listener
  const handleClickOutside = event => {
    const messageBox = document.getElementById('message-box-0')
    const messageBoxTwo = document.getElementById('message-box-1')
    const chromePicker = document.getElementsByClassName('chrome-picker')

    if (chromePicker.length !== 0) {
      if (
        messageBox &&
        !messageBox.contains(event.target) &&
        messageBoxTwo &&
        !messageBoxTwo.contains(event.target) &&
        chromePicker &&
        !chromePicker.contains(event.target)
      ) {
        document.removeEventListener('mousedown', handleClickOutside)
        dispatch(messageBoxHideAction())
      }
    } else {
      if (
        messageBox &&
        !messageBox.contains(event.target) &&
        messageBoxTwo &&
        !messageBoxTwo.contains(event.target)
      ) {
        document.removeEventListener('mousedown', handleClickOutside)
        dispatch(messageBoxHideAction())
      } else if (
        messageBox &&
        !messageBox.contains(event.target) &&
        !messageBoxTwo
      ) {
        dispatch(messageBoxHideAction())
      }
    }
  }

  document.addEventListener('mousedown', handleClickOutside)

  dispatch(
    messageBoxShowAction(
      MessageBoxContent({
        type: MessageBoxType.WARNING,
        title: `<div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
            "
          >
            <Typography>Button Options</Typography>
          </div>`,
        buttons: [],
        component: (
          <ButtonOptionsModal
            editor={editor}
            target={target}
            selection={selectedElement}
            position={editor.model.document.selection.getFirstPosition()}
          />
        ),
        draggable: true,
        callback: () => {
          document.removeEventListener('mousedown', handleClickOutside)
        },
      }),
    ),
  )
}

export const handleHeaderSettingsModal = (dispatch, pageUrl) => {
  // Track the latest settings between renders
  let latestThemeSettings = null

  dispatch(
    messageBoxShowAction(
      MessageBoxContent({
        type: MessageBoxType.WARNING,
        title: `<div style="display: flex; align-items: center; justify-content: center; gap: 8px; color: var(--mcg-dark, #002E47); font-family: Inter; font-size: 16px; font-weight: 400; line-height: 150%;">
            <Typography>Header settings</Typography>
          </div>`,
        buttons: [
          new ButtonData(
            ButtonType.NORMAL,
            'Cancel',
            ButtonActionType.NO,
            () => {
              dispatch(messageBoxHideAction())
            },
          ),
          new ButtonData(
            ButtonType.ACTION,
            'Save',
            ButtonActionType.YES,
            () => {
              if (latestThemeSettings) {
                const patchAction =
                  pageUrl === 'mini-course'
                    ? patchCourseLandingPageAction
                    : patchCollectionLandingPageAction

                dispatch(
                  patchAction(
                    latestThemeSettings.id,
                    pageUrl !== 'collection'
                      ? [
                          {
                            path: 'sections',
                            value: [
                              {
                                type: 'Header',
                                content: {
                                  alignment:
                                    latestThemeSettings.selectedPosition,
                                  image: latestThemeSettings.background,
                                },
                              },
                              latestThemeSettings.landingPageSettings
                                ?.sections?.[1] || {
                                type: 'Main',
                                content: {
                                  html:
                                    latestThemeSettings.landingPageSettings
                                      ?.sections?.[1]?.content?.html || '',
                                },
                              },
                            ],
                          },

                          {
                            path: 'localizations',
                            value: {
                              startButton:
                                latestThemeSettings.landingPageSettings
                                  ?.localizations?.startButton ||
                                'Start Course',
                              resumeButton:
                                latestThemeSettings.landingPageSettings
                                  ?.localizations?.resumeButton ||
                                'Resume Course',
                            },
                          },
                        ]
                      : [
                          {
                            path: 'sections',
                            value: [
                              {
                                type: 'Header',
                                content: {
                                  alignment:
                                    latestThemeSettings.selectedPosition,
                                  image: latestThemeSettings.background,
                                },
                              },
                              latestThemeSettings.landingPageSettings
                                ?.sections?.[1] || {
                                type: 'Main',
                                content: {
                                  html:
                                    latestThemeSettings.landingPageSettings
                                      ?.sections?.[1]?.content?.html || '',
                                },
                              },
                            ],
                          },
                        ],
                  ),
                )
                const positionMap = {
                  left: 'flex-start',
                  center: 'center',
                  right: 'flex-end',
                }
                Array.from(
                  document.getElementsByClassName('editor-header-content'),
                ).forEach(element => {
                  element.style.alignItems =
                    positionMap[latestThemeSettings.selectedPosition]
                  element.style.textAlign = latestThemeSettings.selectedPosition
                })
                Array.from(
                  document.getElementsByClassName('editor-header-container'),
                ).forEach(element => {
                  element.style.background = `linear-gradient(0deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.3) 100%), 
                  url(${latestThemeSettings.background}) lightgray 50% / cover no-repeat`
                })
                const startButtonText =
                  latestThemeSettings.landingPageSettings?.localizations
                    ?.startButton
                if (startButtonText) {
                  document
                    .querySelectorAll(
                      '.start-button-text-header, .start-button-text',
                    )
                    .forEach(element => (element.textContent = startButtonText))
                }

                // Update resume button text
                const resumeButtonText =
                  latestThemeSettings.landingPageSettings?.localizations
                    ?.resumeButton
                if (resumeButtonText) {
                  document
                    .querySelectorAll(
                      '.resume-button-text-header, .resume-button-text',
                    )
                    .forEach(
                      element => (element.textContent = resumeButtonText),
                    )
                }
              }

              dispatch(messageBoxHideAction())
            },
          ),
        ],
        maxWidth: '920px',
        component: (
          <HeaderSettings
            onSave={settings => {
              // Store the complete settings object
              latestThemeSettings = settings
            }}
          />
        ),
        callback: () => {
          dispatch(messageBoxHideAction())
        },
      }),
    ),
  )
}

export const handleAddModal = (dispatch, editor, selection) => {
  hideAllMessageBoxes(dispatch)

  let isSelectOpen = false

  // Function to check if clicked element is part of a select component
  const isSelectComponent = element => {
    // Check for various MUI select-related classes
    return (
      element.classList?.contains('MuiSelect-select') ||
      element.classList?.contains('MuiMenu-paper') ||
      element.classList?.contains('MuiMenuItem-root') ||
      element.classList?.contains('MuiBackdrop-root') ||
      element.getAttribute('role') === 'listbox' ||
      element.getAttribute('role') === 'option' ||
      // Also check parents
      element.closest('.MuiSelect-root') ||
      element.closest('.MuiMenu-paper') ||
      element.closest('[role="listbox"]')
    )
  }

  // Add event listener for select open state
  const handleSelectOpen = () => {
    isSelectOpen = true
  }

  const handleSelectClose = () => {
    isSelectOpen = false
  }

  // Find and add listeners to select elements
  setTimeout(() => {
    const selectElements = document.querySelectorAll(
      '.MuiSelect-select, [role="button"][aria-haspopup="listbox"]',
    )
    selectElements.forEach(select => {
      select.addEventListener('mousedown', handleSelectOpen)
      // We need to monitor document for the close event
      document.addEventListener('mouseup', e => {
        // Small delay to let the click event fully process
        setTimeout(() => {
          if (!isSelectComponent(e.target)) {
            handleSelectClose()
          }
        }, 100)
      })
    })
  }, 100) // Small delay to ensure modal is rendered

  // Setup the outside click handler
  const handleClickOutside = event => {
    const messageBox = document.getElementById('message-box-0')
    const messageBoxTwo = document.getElementById('message-box-1')
    const chromePicker = document.getElementsByClassName('chrome-picker')[0]

    // If select is open, don't close the modal
    if (isSelectOpen || isSelectComponent(event.target)) {
      return
    }

    // Check if chrome picker is open
    if (
      chromePicker &&
      (chromePicker === event.target || chromePicker.contains(event.target))
    ) {
      return
    }

    // Check message boxes
    if (messageBox && messageBox.contains(event.target)) {
      return
    }

    if (messageBoxTwo && messageBoxTwo.contains(event.target)) {
      return
    }

    // If we get here, user clicked outside all relevant elements
    document.removeEventListener('mousedown', handleClickOutside)
    dispatch(messageBoxHideAction())
  }

  document.addEventListener('mousedown', handleClickOutside)

  dispatch(
    messageBoxShowAction(
      MessageBoxContent({
        type: MessageBoxType.WARNING,
        title: `<div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
            "
          >
            <Typography>Block Options</Typography>
          </div>`,
        buttons: [],
        component: <BlockOptionsModal editor={editor} selection={selection} />,
        draggable: true,
        callback: () => {
          // Clean up event listeners when modal is closed
          document.removeEventListener('mousedown', handleClickOutside)
          const selectElements = document.querySelectorAll(
            '.MuiSelect-select, [role="button"][aria-haspopup="listbox"]',
          )
          selectElements.forEach(select => {
            select.removeEventListener('mousedown', handleSelectOpen)
          })
        },
      }),
    ),
  )
}
export const handleIconButtonOptions = (dispatch, editor, target) => {
  hideAllMessageBoxes(dispatch)
  const position = editor.model.document.selection.getFirstPosition()

  // Add click outside listener

  const handleIconSelect = icon => {
    if (editor) {
      editor.model.change(writer => {
        const cardIconButton = writer.createElement('cardIconButton')

        const simpleIcon = writer.createElement('simpleIcon', {
          icon: icon,
          iconname: icon,
          width: 24,
          height: 24,
        })

        // Try to get the existing button at position
        const existingButton = position.parent.getChild(position.offset)
        if (existingButton && existingButton.name === 'cardIconButton') {
          writer.remove(existingButton)
        }

        editor.model.insertContent(cardIconButton, position)
        writer.append(simpleIcon, cardIconButton)
      })
    }
  }
  const handleClickOutside = event => {
    const messageBox = document.getElementById('message-box-0')
    if (messageBox && !messageBox.contains(event.target)) {
      document.removeEventListener('mousedown', handleClickOutside)
      dispatch(messageBoxHideAction('message-box-0'))
    }
  }

  document.addEventListener('mousedown', handleClickOutside)
  dispatch(
    messageBoxShowAction(
      MessageBoxContent({
        type: MessageBoxType.WARNING,
        title: `<div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
            "
          >
            <Typography>Select Icon</Typography>
          </div>`,
        buttons: [],
        component: (
          <SelectedIcon
            editor={editor}
            target={target}
            onIconSelect={handleIconSelect}
          />
        ),
        draggable: true,
        callback: () => {},
      }),
    ),
  )
}

const addDragListenersWithTimeout = () => {
  setTimeout(() => {
    const dragAreas = document.querySelectorAll('.drop-area-narrow')
    dragAreas.forEach(area => {
      if (!area.hasEventListener) {
        addDragListeners(area)
        area.hasEventListener = true
      }
    })
    const dropAreaWides = document.querySelectorAll('.drop-area-wide')
    dropAreaWides.forEach(area => {
      if (!area.hasEventListener) {
        addDragListeners(area)
        area.hasEventListener = true
      }
    })
  }, 0)
}

const handleNoWrappersCase = (position, root, isdropAreaWide) => {
  const positionIndex = Array.from(root.getChildren()).indexOf(position)
  const previousElement =
    positionIndex > 0 ? root.getChild(positionIndex - 1) : null
  const nextElement =
    positionIndex < root.childCount - 1
      ? root.getChild(positionIndex + 1)
      : null

  if (!isdropAreaWide(previousElement) && !isdropAreaWide(nextElement)) {
    window.editor.model.change(writer => {
      const dropAreaWide = writer.createElement('dropAreaNarrow')
      writer.insert(dropAreaWide, position)
    })

    setTimeout(() => {
      const dragArea = document.querySelector('.drop-area-narrow')
      if (dragArea && !dragArea.hasEventListener) {
        addDragListeners(dragArea)
        dragArea.hasEventListener = true
      }
    }, 0)
  }
}

export const updateButtonVisibility = (containerElement, editor) => {
  try {
    // Short delay to ensure the DOM is updated
    setTimeout(() => {
      // Find all wrapper elements in the DOM
      const wrapperElements = document.querySelectorAll(
        '.simple-box-wrapper, .editor-outline',
      )

      // Exit if no elements found
      if (!wrapperElements.length) {
        return
      }

      // Get all drop areas
      const dropAreas = document.querySelectorAll('.drop-area-wide')

      // Process each wrapper element
      wrapperElements.forEach(wrapper => {
        // Find the add buttons for this wrapper
        const addAboveButton = wrapper.querySelector(
          '.simple-box-wrapper-add-above, .editor-outline-add-above',
        )
        const addBelowButton = wrapper.querySelector(
          '.simple-box-wrapper-add-below',
        )

        // Skip if no buttons found
        if (!addAboveButton && !addBelowButton) {
          return
        }

        // Determine if there's a drop area above/below this wrapper
        const wrapperRect = wrapper.getBoundingClientRect()

        let hasDropAbove = false
        let hasDropBelow = false

        // Check each drop area to see if it's above or below this wrapper
        dropAreas.forEach(dropArea => {
          const dropRect = dropArea.getBoundingClientRect()

          // If drop area is directly above this wrapper
          if (Math.abs(dropRect.bottom - wrapperRect.top) < 2) {
            hasDropAbove = true
          }

          // If drop area is directly below this wrapper
          if (Math.abs(dropRect.top - wrapperRect.bottom) < 2) {
            hasDropBelow = true
          }
        })

        // Update button visibility based on drop area presence
        if (addAboveButton) {
          addAboveButton.style.display = hasDropAbove ? 'none' : 'block'
        }

        if (addBelowButton) {
          addBelowButton.style.display = hasDropBelow ? 'none' : 'block'
        }
      })
    }, 50) // Small delay to ensure DOM is updated
  } catch (error) {
    console.error('Error in updateButtonVisibility:', error)
  }
}
const updateButtonStyles = (
  writer,
  addAboveButton,
  addBelowButton,
  initialdropAreaWidesLength,
  dropAreaWides,
  hasDropAbove,
  hasDropBelow,
) => {
  if (addAboveButton) {
    writer.setAttribute(
      'style',
      hasDropAbove ? 'display: none' : 'display: block',
      addAboveButton,
    )
  }
  if (initialdropAreaWidesLength === 0) {
    if (addAboveButton) {
      writer.setAttribute('style', 'display: block', addAboveButton)
    }
    if (addBelowButton) {
      writer.setAttribute('style', 'display: block', addBelowButton)
    }
  } else {
    if (addBelowButton) {
      writer.setAttribute(
        'style',
        dropAreaWides.length === 0
          ? 'display: block'
          : hasDropBelow
          ? 'display: none'
          : 'display: block',
        addBelowButton,
      )
    }
  }
}
export const replacedropAreaWideContent = (
  editor,
  newData,
  type,
  dispatch,
  Embed,
  fontFamily,
  language,
) => {
  if (type === 'embed') {
    editor.model.change(writer => {
      const viewRoot = editor.editing.view.document.getRoot()
      const dropAreaWides = Array.from(viewRoot.getChildren()).filter(
        element => element.hasClass && element.hasClass('drop-area-wide'),
      )

      if (dropAreaWides.length > 0) {
        // Existing drop area handling logic
        const modeldropAreaWides = dropAreaWides.map(viewElement => {
          const viewPosition = editor.editing.view.createPositionBefore(
            viewElement,
          )
          const modelPosition = editor.editing.mapper.toModelPosition(
            viewPosition,
          )
          return modelPosition.nodeAfter
        })

        modeldropAreaWides.forEach(dropAreaWide => {
          if (dropAreaWide) {
            const range = writer.createRangeOn(dropAreaWide)
            const position = range.start
            const doubleClick = true
            handleAddEmbed(
              newData,
              position,
              editor,
              dispatch,
              Embed,
              writer,
              dropAreaWide,
              doubleClick,
            )
          }
        })
      } else {
        // Check for editor footer
        const viewRoot = editor.editing.view.document.getRoot()
        const editorFooter = Array.from(viewRoot.getChildren()).find(
          element => element.hasClass && element.hasClass('editor-outline'),
        )

        let position
        if (editorFooter) {
          // Insert before the editor footer
          const viewPosition = editor.editing.view.createPositionBefore(
            editorFooter,
          )
          const modelPosition = editor.editing.mapper.toModelPosition(
            viewPosition,
          )
          position = modelPosition
        } else {
          // No footer found, insert at the end
          position = writer.createPositionAt(
            editor.model.document.getRoot(),
            'end',
          )
        }

        const doubleClick = true
        handleAddEmbed(
          newData,
          position,
          editor,
          dispatch,
          Embed,
          writer,
          null,
          doubleClick,
        )
      }
    })
  } else if (type === 'actions' && newData.value === 'interactiveActivity') {
    editor.model.change(writer => {
      const viewRoot = editor.editing.view.document.getRoot()
      const dropAreaWides = Array.from(viewRoot.getChildren()).filter(
        element => element.hasClass && element.hasClass('drop-area-wide'),
      )

      if (dropAreaWides.length > 0) {
        // Existing drop area handling logic
        const modeldropAreaWides = dropAreaWides.map(viewElement => {
          const viewPosition = editor.editing.view.createPositionBefore(
            viewElement,
          )
          const modelPosition = editor.editing.mapper.toModelPosition(
            viewPosition,
          )
          return modelPosition.nodeAfter
        })

        modeldropAreaWides.forEach(dropAreaWide => {
          if (dropAreaWide) {
            const range = writer.createRangeOn(dropAreaWide)
            const position = range.start
            const doubleClick = true
            handleAddInterActive(
              newData,
              position,
              editor,
              dispatch,
              Embed,
              writer,
              dropAreaWide,
              doubleClick,
              fontFamily,
              language,
            )
          }
        })
      } else {
        // Check for editor footer
        const viewRoot = editor.editing.view.document.getRoot()
        const editorFooter = Array.from(viewRoot.getChildren()).find(
          element => element.hasClass && element.hasClass('editor-outline'),
        )

        let position
        if (editorFooter) {
          // Insert before the editor footer
          const viewPosition = editor.editing.view.createPositionBefore(
            editorFooter,
          )
          const modelPosition = editor.editing.mapper.toModelPosition(
            viewPosition,
          )
          position = modelPosition
        } else {
          // No footer found, insert at the end
          position = writer.createPositionAt(
            editor.model.document.getRoot(),
            'end',
          )
        }

        const doubleClick = true
        handleAddInterActive(
          newData,
          position,
          editor,
          dispatch,
          Embed,
          writer,
          null,
          doubleClick,
          fontFamily,
          language,
        )
      }
    })
  } else {
    editor.model.change(writer => {
      const viewRoot = editor.editing.view.document.getRoot()
      const dropAreaWides = Array.from(viewRoot.getChildren()).filter(
        element => element.hasClass && element.hasClass('drop-area-wide'),
      )

      if (dropAreaWides.length > 0) {
        // Existing content replacement logic
        const modeldropAreaWides = dropAreaWides.map(viewElement => {
          const viewPosition = editor.editing.view.createPositionBefore(
            viewElement,
          )
          const modelPosition = editor.editing.mapper.toModelPosition(
            viewPosition,
          )
          return modelPosition.nodeAfter
        })

        const viewFragment = editor.data.processor.toView(newData.html)
        const modelFragment = editor.data.toModel(viewFragment)

        modeldropAreaWides.forEach(dropAreaWide => {
          if (dropAreaWide) {
            const range = writer.createRangeOn(dropAreaWide)
            writer.remove(dropAreaWide)
            editor.model.insertContent(modelFragment, range.start)
          }
        })
      } else {
        // Check for editor footer
        const viewRoot = editor.editing.view.document.getRoot()
        const editorFooter = Array.from(viewRoot.getChildren()).find(
          element => element.hasClass && element.hasClass('editor-outline'),
        )

        const viewFragment = editor.data.processor.toView(newData.html)
        const modelFragment = editor.data.toModel(viewFragment)

        if (editorFooter) {
          // Insert before the editor footer
          const viewPosition = editor.editing.view.createPositionBefore(
            editorFooter,
          )
          const modelPosition = editor.editing.mapper.toModelPosition(
            viewPosition,
          )
          editor.model.insertContent(modelFragment, modelPosition)
        } else {
          // No footer found, insert at the end
          const position = writer.createPositionAt(
            editor.model.document.getRoot(),
            'end',
          )
          editor.model.insertContent(modelFragment, position)
        }
      }
    })
  }
}
